/* eslint-disable @typescript-eslint/no-explicit-any */
import StyleOrderUpdatedComponent from "@/components/StyleOrderUpdated";
import { useEffect, useState } from "react";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import FetchDataWithLoader from "@/components/InfinityLoading";
import InfiniteScroll from "react-infinite-scroll-component";
import { Alert } from "react-bootstrap";
import { showToast } from "@/api/notification";
import { useParams } from "react-router-dom";
// import { set } from "lodash";
function StyleOrderUpdated() {
  const { categorySlug } = useParams<{ categorySlug?: string }>();
  const { getApi, postApi, error } = useGeneralApiCall();
  const [page, setPage] = useState(1);
  const [items, setItems] = useState<any[]>([]);
  const [nextapi, setnextapi] = useState("");
  const [nextapi1, setnextapi1] = useState("");

  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [setCategories] = useState<any>("");

  const getData = async (come: boolean) => {
    let response: any;

    // ✅ Case 1: categories is empty → use style API
    if (categorySlug === undefined) {
      // If we already have a nextapi (pagination), fetch from it
      if (nextapi1 !== "") {
        response = await getApi(`api/style/v1/style/${nextapi1}`);
        setItems((prev) => [
          ...prev,
          ...(Array.isArray(data.results) ? data.results : []),
        ]);
      } else {
        response = await getApi(`api/style/v1/style/`);
        setItems(() => data.results);
      }

      const data: any = response.data;
      // ✅ Handle pagination
      if (!data.next) {
        setHasMore(false);
        setnextapi1("");
        setnextapi("");
      } else {
        setHasMore(true);
        setnextapi1(data.next);
        setnextapi("");
      }

      return;
    }

    // ✅ Case 2: categories is not empty → use category-photo API
    if (come) {
      response = await getApi(`api/cat/v1/category-photo/${categorySlug}/`);
      setItems(response.data.results);
    } else if (hasMore && nextapi) {
      response = await getApi(nextapi); // fetch next page
      setItems((prev) => [
        ...prev,
        ...(Array.isArray(response.data.results) ? response.data.results : []),
      ]);
    } else {
      response = await getApi(`api/cat/v1/category-photo/${categorySlug}/`);
      setItems(response.data.results);
      setnextapi("");
    }

    const data: any = response.data;

    // ✅ Handle pagination
    if (!data.next) {
      setnextapi1("");
      setHasMore(false);
      setnextapi("");
    } else {
      setnextapi1("");
      setHasMore(true);
      setnextapi(data.next);
    }

    // ✅ Append results
  };

  useEffect(() => {
    getData(true);
  }, [categorySlug]);

  const handlePostApi = async (images: any) => {
    setnextapi("");
    setIsLoading(true);
    const oldids = items.map((it) => it.style_id);

    const newids = images.map((it: any) => it.style_id);

    try {
      const res = await postApi("api/style/v1/reorder-styles/", {
        old: oldids,
        new: newids,
      });
      if (res?.status === 200) {
        // getData(true);
        setItems([...(Array.isArray(images) ? images : [])]);
        showToast({ message: "Updated Successfully", type: "success" });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    setPage(page + 1);
    if (hasMore) {
      getData(false);
    }
  };

  return (
    <>
      {error ? (
        <Alert variant="danger" className="text-center">
          {error}
        </Alert>
      ) : (
        <div
          id="scrollableDiv"
          style={{
            height: "82vh",
            overflow: "auto",
          }}
        >
          <InfiniteScroll
            dataLength={items.length}
            next={loadMore}
            hasMore={hasMore}
            loader={<FetchDataWithLoader />}
            endMessage={
              <Alert variant="info" className="text-center">
                No more styles to load
              </Alert>
            }
          >
            <StyleOrderUpdatedComponent
              initialImagesTemp={items}
              path="/style/details"
              title="STYLE ORDER MANAGEMENT"
              handlePostApi={handlePostApi}
              categories={categorySlug}
              setCategories={setCategories}
              isLoading={isLoading}
            />
          </InfiniteScroll>
        </div>
      )}
    </>
  );
}

export default StyleOrderUpdated;
